module.exports = __webpack_public_path__ + "static/media/reporter.7f797d13.png";